import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42c9f77e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fbc_item" }
const _hoisted_2 = {
  key: 0,
  class: "fbc_item_main"
}
const _hoisted_3 = {
  key: 1,
  class: "fbc_item_main"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "privacy_check"
}
const _hoisted_6 = {
  key: 3,
  class: "fbc_item_main privacy_tbody"
}
const _hoisted_7 = {
  key: 0,
  class: "imgText_area"
}
const _hoisted_8 = { class: "privacy_check" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" 1.点击报名后弹出隐私协议（报名弹出模式）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("2.进入页面立即弹出隐私协议（进入弹出模式）")
], -1))
const _hoisted_10 = { class: "fbc_item_opera" }
const _hoisted_11 = { class: "fbc_item_check_wrap" }
const _hoisted_12 = { class: "fbc_item_check_group" }
const _hoisted_13 = {
  key: 0,
  class: "fbc_item_check_text"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/wallet/recharge" }, "充值", -1))
const _hoisted_16 = {
  key: 1,
  class: "fbc_item_check_text"
}

import {
  ref,
  computed,
  watch,
  unref,
  withDefaults,
  onMounted,
  onBeforeUnmount,
  reactive,
  nextTick,
  shallowReactive,
} from 'vue';
import { Radio, Input, Popover, message } from 'ant-design-vue';
import type { FormObj, SwitchForm, Option, ModeData } from './type';
import { sourceTxtOption, sourceTypeOption } from './signupWatch';
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import { getToken } from '@/plugins/cookie';
import axios from 'axios';
import http from '@/api';
import { PlusOutlined, MinusOutlined, QuestionCircleFilled } from '@ant-design/icons-vue';
import { useHomeStore } from '@/pinia/home';
import { apikey } from '@/components/CTinymce';

interface IProps {
  modelValue: any;
  switchObj: SwitchForm;
  index: number;
  editRole: boolean;
  childe: any;
  formArr: FormObj[];
  modeData: ModeData[];
}
interface ModeSelect {
  value: number | string;
  visible: boolean;
  options: { label: string; value: number }[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyItem',
  props: {
    modelValue: null,
    switchObj: null,
    index: null,
    editRole: { type: Boolean, default: false },
    childe: null,
    formArr: null,
    modeData: null
  },
  emits: ['del:onDelItem', 'update:modelValue', 'login:onChangeItemIsLogin', 'login:onChangeMergeStatus'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: any, switchObj: SwitchForm, index: number, editRole: boolean, childe: any, formArr: FormObj[], modeData: ModeData[] };

const token = getToken();
const imagesHandler: any = (blobInfo: any, success: any, failure: any) => {
  const formData = new FormData();
  formData.append('images', blobInfo.blob(), blobInfo.filename());
  formData.append('token', token as any);
  if (formData) {
    axios.post('/api/v1/common/upload_images', formData).then((res) => {
      if (res.data.code == 200) {
        const url = res.data.data.url;
        success(url);
      } else {
        failure('');
      }
    });
  }
};
const initRef = shallowReactive({
  selector: 'editor_id',
  menubar: false,
  plugins: 'image paste code link',
  images_file_types: 'jpg,jpeg,png,gif',
  statusbar: false, // 隐藏底部状态栏
  automatic_uploads: true,
  images_upload_handler: imagesHandler,
  language: 'zh_CN',
  toolbar:
    'code undo redo image forecolor backcolor bold italic underline strikethrough | alignleft aligncenter alignright alignjustify \
          outdent indent ormatselect | fontsizeselect | formatselect | fontselect | link',
  height: 230,
  convert_urls: false,
  fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
  font_formats:
    '宋体=SimSun; 新宋体=NSimSun; 仿宋=FangSong; 黑体=SimHei; 微软雅黑=Microsoft Yahei; 微软正黑体=Microsoft JhengHei; 楷体=KaiTi;',

  // image_dimensions: false,
  content_style: 'img{width:100%;height:auto;}img.no-fill{width:auto;max-width:100%;}',
  image_class_list: [
    { title: '全屏显示', value: '' },
    { title: '原始尺寸', value: 'no-fill' },
  ],
  default_link_target: '_blank',
});

// init.height = 230px
const PrivewRadioOption: Option[] = [
  { label: '勾选模式', value: '1' },
  { label: '报名弹出', value: '2' },
  { label: '进入弹出', value: '3' },
];

const ChoiceOption: Option[] = [
  { label: '单选', value: '1' },
  { label: '多选', value: '2' },
];

const aInput = Input;
const aRadioGroup = Radio.Group;
const aPopover = Popover;



const switchForm = ref({
  isLogin: false,
  isUserName: false,
  isMerge: false,
});
switchForm.value = unref(props.switchObj);
const form = ref<FormObj>({
  id: 0,
  isInternational: false,
  isLogin: false,
  isUser_name: false,
  isVerify: false,
  isMerge: false,
  isMultipleChoice: '1',
  option: [],
  options: sourceTxtOption,
  options2: sourceTypeOption,
  preview_radio: '1',
  require: true,
  select: '1',
  select2: '9',
  tips: '请输入内容',
  title: '',
  type: 'text',
  value: '',
  verify_code: '',
});
form.value = unref(props.modelValue);
const requireCheckBoxVisible = computed(() => !(form.value.select2 === '8' && form.value.preview_radio === '2'));
watch(form.value, (newVal) => {
  // 隐私 选项下，显示模式为: 报名弹出时,取消必填选项
  if (newVal.select2 === '8' && newVal.preview_radio === '2') {
    form.value.require = false;
  }
  emit('update:modelValue', newVal);
});

const homeStore = useHomeStore();
// 显示国际号码
const checkBoxRole = computed(() => homeStore.funcData?.internationalCheckBox);
const txtWhitelist = ['6', '7', '9'];
const isShowSelect = computed(() => txtWhitelist.includes(form.value.select2));
const isShowInputGroup = computed(() => form.value.select === '2' && form.value.select2 !== '8');
const isShowRadioGroup = computed(() => isShowInputGroup.value && form.value.select2 !== '2');
const onAddOption = () => {
  if (form.value.select2 === '2' && form.value.option.length >= 3) {
    message.destroy();
    message.warn('性别仅可添加最多三项！');
    return;
  }
  form.value.option.push({ title: '', value: '' });
};

const onDelOption = (index: number) => {
  form.value.option.splice(index, 1);
};

const onDelParentItem = (index: number) => {
  emit('del:onDelItem', index);
};

// 隐私模版
const modeData = ref<ModeData[]>([]);
const modeSelect = reactive<ModeSelect>({
  value: '',
  visible: false,
  options: [],
});

props.modeData.forEach((e, index) => {
  modeSelect.options.push({
    label: e.name,
    value: index,
  });
});

modeData.value = unref(props.modeData);
const onChangeContent = () => {
  form.value.title = modeData.value[modeSelect.value as number].title;
  form.value.option = [
    {
      title: modeData.value[modeSelect.value as number].content,
    },
  ];
};

const isShow = computed(() => {
  return props.formArr.some((e) => {
    if (e.select2 === '8' && e.options2) {
      return true;
    }
  });
});

const disabled = () => {
  if (isShow.value) {
    sourceTypeOption.forEach((e) => {
      if (e.value === '8') e.disabled = true;
    });
  }
  if (!isShow.value) {
    sourceTypeOption.forEach((e) => {
      if (e.value === '8') e.disabled = false;
    });
  }
};
disabled();

// type 为区分当前选项的类型
const word = ['text', 'question', 'answers', 'phone', 'email', 'preview', 'image'];
const onChangeTitle = () => {
  disabled();
  const key = parseInt(form.value.select2) - 1;
  form.value.title = form.value.options2[key].label;
  form.value.preview_radio = '1';
  form.value.select = '1';
  form.value.option = [];
  switch (true) {
    case ['1', '3'].includes(form.value.select2):
      // text
      form.value.type = word[0];
      modeSelect.visible = false;
      break;
    case ['6', '7'].includes(form.value.select2):
      form.value.select = '2';
      form.value.option = [
        { title: '', value: '' },
        { title: '', value: '' },
        { title: '', value: '' },
      ];
      form.value.type = word[1];
      modeSelect.visible = false;
      break;
    case form.value.select2 === '2':
      // question
      form.value.option = [
        { title: '女', value: '女' },
        { title: '男', value: '男' },
      ];
      form.value.select = '2';
      form.value.type = word[1];
      modeSelect.visible = false;
      break;
    case form.value.select2 === '4':
      // phone
      form.value.type = word[3];
      modeSelect.visible = false;
      break;
    case form.value.select2 === '5':
      // email
      form.value.type = word[4];
      modeSelect.visible = false;
      break;
    case form.value.select2 === '8':
      // preview
      modeSelect.visible = true;
      form.value.option = [
        {
          title: '',
        },
      ];
      form.value.title = '同意并遵守《隐私声明》';
      form.value.type = word[5];
      form.value.isLogin = false;
      form.value.isUser_name = false;
      break;
    case form.value.select2 === '10':
      form.value.type = word[6];
      break;
    default:
      modeSelect.visible = false;
      form.value.type = word[0];
      break;
  }
};

const onChangeLoginStatus = () => {
  if (form.value.isLogin) {
    emit('login:onChangeItemIsLogin', form.value);
  }
};
// 数据合并 选择框 触发
const onChangeMergeStatus = () => {
  if (switchForm.value.isMerge) {
    emit('login:onChangeMergeStatus', form.value);
  }
};
// 数据合并禁用情况下 取消选中 重新触发
const changeDisable = () => {
  if (!form.value.require || form.value.select === '2') {
    form.value.isMerge = false;
    emit('login:onChangeMergeStatus', form.value);
  }
};
/**
 * 以下为富文本编辑器
 */

// 文本类型触发事件
const onChangeTxtType = () => {
  if (form.value.select === '1') {
    form.value.type = word[0];
  } else {
    changeDisable();
    form.value.type = word[1];
    if (!form.value.option || form.value.option.length === 0) {
      form.value.option = [
        { title: '', value: '' },
        { title: '', value: '' },
        { title: '', value: '' },
      ];
    }
  }
};

onMounted(() => {
  tinymce.init({});
});
onBeforeUnmount(() => {
  tinymce.remove();
});
const reInit = computed(() => {
  if (form.value.select2 === '8' && form.value.option[0]) {
    return true;
  } else {
    return false;
  }
});

watch(props.childe, () => {
  tinymce.EditorManager.execCommand('mceRemoveEditor', true, 'editor_id');
  if (reInit.value) {
    nextTick(() => {
      tinymce.init({
        selector: 'editor_id',
        menubar: false,
        plugins: 'image paste code',
        images_file_types: 'jpg,jpeg,png,gif',
        statusbar: false, // 隐藏底部状态栏
        automatic_uploads: true,
        images_upload_handler: imagesHandler,
        language: 'zh_CN',
        toolbar:
          'code undo redo image forecolor backcolor bold italic underline strikethrough | alignleft aligncenter alignright alignjustify \
          outdent indent ormatselect | fontsizeselect | formatselect | fontselect',
        height: 230,
        convert_urls: false,
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
        font_formats:
          '宋体=SimSun; 新宋体=NSimSun; 仿宋=FangSong; 黑体=SimHei; 微软雅黑=Microsoft Yahei; 微软正黑体=Microsoft JhengHei; 楷体=KaiTi;',
      });
      tinymce.EditorManager.execCommand('mceAddEditor', true, 'editor_id');
    });
  }
});

const newsObj: any = ref({ balance: 0, intl_sms_balance: 0, sms_balance: 0 }); // balance  是余额 sms_balance 国内短信  intl_sms_balance  国际短信
const newsObjState = ref(0);
const sendMessage = () => {
  if (form.value.isVerify && !newsObjState.value) {
    http.live
      .getBalance()
      .then((res) => {
        newsObj.value = res.data.data;
        newsObjState.value = 1;
      })
      .catch((err) => console.error(err.data.error));
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (props.editRole)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(aInput), {
              value: form.value.title,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
              class: "fbc_item_input fbc_item_form",
              maxlength: 60,
              placeholder: "请输入",
              onChange: onChangeMergeStatus
            }, {
              suffix: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(form.value.title.length) + "/60", 1)
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(_component_a_select, {
              class: "fbc_item_select fbc_item_form",
              value: form.value.select2,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.select2) = $event)),
              options: form.value.options2,
              onChange: onChangeTitle,
              placeholder: "默认"
            }, null, 8, ["value", "options"]),
            _withDirectives(_createVNode(_component_a_select, {
              class: "fbc_item_select fbc_item_form",
              value: form.value.select,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.select) = $event)),
              onChange: onChangeTxtType,
              options: form.value.options
            }, null, 8, ["value", "options"]), [
              [_vShow, _unref(isShowSelect)]
            ]),
            _withDirectives(_createVNode(_component_a_select, {
              class: "fbc_item_select fbc_item_form long",
              value: modeSelect.value,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((modeSelect.value) = $event)),
              options: modeSelect.options,
              onChange: onChangeContent
            }, null, 8, ["value", "options"]), [
              [_vShow, modeSelect.visible]
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(aInput), {
              value: form.value.title,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.title) = $event)),
              class: "fbc_item_input fbc_item_form",
              maxlength: 60,
              placeholder: "请输入"
            }, {
              suffix: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(form.value.title.length) + "/60", 1)
              ]),
              _: 1
            }, 8, ["value"])
          ])),
      (_unref(isShowInputGroup))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.option as Option[], (sexItem, sexIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: sexItem.value,
                class: "fbc_item_main sec_tbody"
              }, [
                _createVNode(_unref(aInput), {
                  value: sexItem.title,
                  "onUpdate:value": ($event: any) => ((sexItem.title) = $event),
                  class: "fbc_item_input fbc_item_form",
                  maxlength: 60,
                  placeholder: "请输入"
                }, {
                  suffix: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString((sexItem.title as string).length) + "/60", 1)
                  ]),
                  _: 2
                }, 1032, ["value", "onUpdate:value"]),
                _createVNode(_component_a_button, {
                  class: "sec_btn",
                  type: "primary",
                  onClick: onAddOption
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(PlusOutlined))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  class: "sec_btn",
                  onClick: ($event: any) => (onDelOption(sexIndex))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MinusOutlined))
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128)),
            (_unref(isShowRadioGroup))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_unref(aRadioGroup), {
                    options: ChoiceOption,
                    value: form.value.isMultipleChoice,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.isMultipleChoice) = $event))
                  }, null, 8, ["value"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (form.value.select2 === '8' && form.value.option[0])
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (form.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_unref(Editor), {
                    id: "editor_id",
                    modelValue: form.value.option[0].title,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.option[0].title) = $event)),
                    "api-key": _unref(apikey),
                    init: _unref(initRef)
                  }, null, 8, ["modelValue", "api-key", "init"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(" 显示模式："),
              _createVNode(_unref(aRadioGroup), {
                options: PrivewRadioOption,
                value: form.value.preview_radio,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.preview_radio) = $event))
              }, null, 8, ["value"]),
              _createVNode(_unref(aPopover), { placement: "right" }, {
                content: _withCtx(() => [
                  _hoisted_9
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        (props.editRole)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              class: "fbc_item_opera_del",
              type: "link",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (onDelParentItem(props.index)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("移除 "),
                _createVNode(_component_svg_icon, {
                  class: "mod_btn_icon",
                  "icon-class": "del"
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_button, {
          class: "fbc_item_opera_move",
          type: "link"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mover",
              "icon-class": "drag_icon"
            })
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, props.formArr.length > 1]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_unref(requireCheckBoxVisible))
          ? (_openBlock(), _createBlock(_component_a_checkbox, {
              key: 0,
              class: "fbc_item_check",
              checked: form.value.require,
              "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((form.value.require) = $event)),
              onChange: changeDisable
            }, {
              default: _withCtx(() => [
                _createTextVNode("必填项")
              ]),
              _: 1
            }, 8, ["checked"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_a_checkbox, {
          class: "fbc_item_check",
          disabled: form.value.select2 === '8' || form.value.select2 === '10',
          checked: form.value.isUser_name,
          "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((form.value.isUser_name) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode("设为昵称")
          ]),
          _: 1
        }, 8, ["disabled", "checked"]), [
          [_vShow, switchForm.value.isUserName]
        ]),
        _withDirectives(_createVNode(_component_a_checkbox, {
          class: "fbc_item_check",
          disabled: form.value.select2 === '8' || form.value.select2 === '10',
          checked: form.value.isLogin,
          "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((form.value.isLogin) = $event)),
          onChange: onChangeLoginStatus
        }, {
          default: _withCtx(() => [
            _createTextVNode("登录验证")
          ]),
          _: 1
        }, 8, ["disabled", "checked"]), [
          [_vShow, switchForm.value.isLogin]
        ]),
        (form.value.select2 === '4' && _unref(checkBoxRole))
          ? (_openBlock(), _createBlock(_component_a_checkbox, {
              key: 1,
              class: "fbc_item_check",
              checked: form.value.isInternational,
              "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((form.value.isInternational) = $event))
            }, {
              default: _withCtx(() => [
                _createTextVNode("国际号码")
              ]),
              _: 1
            }, 8, ["checked"]))
          : _createCommentVNode("", true),
        (form.value.select2 === '4')
          ? (_openBlock(), _createBlock(_component_a_checkbox, {
              key: 2,
              class: "fbc_item_check",
              checked: form.value.isVerify,
              "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((form.value.isVerify) = $event)),
              onChange: sendMessage
            }, {
              default: _withCtx(() => [
                _createTextVNode("发送验证码 "),
                _withDirectives(_createElementVNode("span", null, [
                  (newsObj.value.sms_balance === 0 && newsObj.value.intl_sms_balance === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                        _createTextVNode("（您的账户余额：" + _toDisplayString(newsObj.value.balance) + " ）", 1),
                        (newsObj.value.sms_balance <= 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                              _createTextVNode("余额不足时，无法发送验证码，您可以前往 "),
                              _hoisted_15
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "（国内短信包剩余：" + _toDisplayString(newsObj.value.sms_balance) + " 国际短信包剩余：" + _toDisplayString(newsObj.value.intl_sms_balance) + "） ", 1))
                ], 512), [
                  [_vShow, newsObjState.value]
                ])
              ]),
              _: 1
            }, 8, ["checked"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})